import React, { useState } from 'react';
import images from '../../constants/images';
import { useTranslation } from 'react-i18next';
// import i18next from "i18next";
import '../../assets/styles/global.css';
import LanguageSelector from '../../locals/languageSelector';
import styles from './Footer.module.css';
import '../header/shiny.button.css';

const Footer: React.FC = () => {
  const { t, i18n } = useTranslation('global');

  return (
    <footer
      className="relative top-0 left-0 bg-black text-white font font-normal px-8 md:px-10 lg:px-16 xl:px-20 2xl:px-16 py-10"
      style={{ fontFamily: "'Nunito Sans', sans-serif", fontWeight: 400 }}
    >
      <div className="flex flex-col lg:flex-row justify-between pb-6">
        <div
          className={`flex flex-col items-start lg:items-start pb-6 lg:pb-2 ${styles.sectionLogo}`}
        >
          <a href="/">
            <img
              src={images.logo_transparant}
              alt={'Logo'}
              className={`mb-4 2xl:w-52 ${styles.logo}`}
            />
          </a>

          {/* Social Icons */}
          <div className={`flex space-x-3 py-2 lg:pb-16`}>
            <a
              href="https://www.facebook.com/elyumax"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={images.facebook_footer}
                alt="Facebook"
                className={`${styles.icon} 2xl:w-10 hover:scale-125 transition-transform duration-300`}
              />
            </a>
            <a
              href="https://www.instagram.com/elyumax"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={images.instagram_footer}
                alt="Instagram"
                className={`${styles.icon} 2xl:w-10 hover:scale-125 transition-transform duration-300`}
              />
            </a>
            <a
              href=" https://x.com/elyumax"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={images.twitter_footer}
                alt="Twitter"
                className={`${styles.icon} 2xl:w-10 hover:scale-125 transition-transform duration-300`}
              />
            </a>
            <a
              href=" https://www.linkedin.com/company/elyumax"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={images.linkedin_footer}
                alt="LinkedIn"
                className={`${styles.icon} 2xl:w-10 hover:scale-125 transition-transform duration-300`}
              />
            </a>
          </div>

          <img
            src={images.madeInIndia}
            alt={'Make In India'}
            className={`hidden lg:flex lg:w-[122px] lg:h-[56px] xl:w-[144px] xl:h-[64px] 2xl:w-[160px] 2xl:h-[72px] ${styles.makeInIndia}`}
          />
        </div>
        <div className="flex justify-around gap-8 flex-col md:flex-row">
          <div
            className={`flex flex-col md:w-24 lg:w-20 xl:w-24 2xl:w-28  ${styles.links}`}
          >
            <span className={`pb-4 text-base 2xl:text-lg  ${styles.title}`}>
              {t('footer.quick-links.title')}
            </span>
            <a
              href="/"
              className={`pb-2 text-sm 2xl:text-base hover:underline ${styles.text}`}
            >
              {t('footer.quick-links.links.link-1')}
            </a>
            <a
              href="/about-us"
              className={`pb-2 text-sm 2xl:text-base hover:underline ${styles.text}`}
            >
              {t('footer.quick-links.links.link-2')}
            </a>
            <a
              href="/certifications"
              className={`pb-2 text-sm 2xl:text-base hover:underline ${styles.text}`}
            >
              {t('footer.quick-links.links.link-3')}
            </a>
            <a
              href="/our-process"
              className={`pb-2 text-sm 2xl:text-base hover:underline ${styles.text}`}
            >
              {t('footer.quick-links.links.link-4')}
            </a>
          </div>
          <div
            className={`flex flex-col md:w-32 lg:w-28 xl:w-32 2xl:w-36 ${styles.help}`}
          >
            <span className={`pb-4 text-base 2xl:text-lg ${styles.title}`}>
              {t('footer.help-and-support.title')}
            </span>
            <a
              href="/careers"
              className={`pb-2 text-sm 2xl:text-base hover:underline ${styles.text}`}
            >
              {t('footer.help-and-support.help.help-1')}
            </a>
            <a
              href="/contact-us"
              className={`pb-2 text-sm 2xl:text-base hover:underline ${styles.text}`}
            >
              {t('footer.help-and-support.help.help-2')}
            </a>
            {/* Language Selection Component */}
            <LanguageSelector />
          </div>
          <div
            className={`flex flex-col md:w-56 lg:w-44 xl:w-52 2xl:w-56 ${styles.touch}`}
          >
            <span className={`pb-4 text-base 2xl:text-lg ${styles.title}`}>
              {t('footer.get-in-touch.title')}
            </span>
            <a
              href="tel:+919909998890"
              target="_blank"
              rel="noopener noreferrer"
              className={`flex pb-2 text-sm 2xl:text-base hover:underline ${styles.text}`}
            >
              <img
                src={images.phone}
                alt={'Phone'}
                className={`pr-3 ${styles.socialIcon}`}
              />
              +91-9909998890
            </a>
            <a
              href="mailto:hello@elyumax.com"
              target="_blank"
              rel="noopener noreferrer"
              className={`flex pb-2 text-sm 2xl:text-base hover:underline ${styles.text}`}
            >
              <img
                src={images.mail}
                alt={'E-Mail'}
                className={`pr-4 ${styles.socialIcon}`}
              />
              hello@elyumax.com
            </a>
            <a
              href="https://www.google.com/maps/place/Hetva+Enterprise/@21.4690196,73.0300072,17z/data=!3m1!4b1!4m6!3m5!1s0x3be03d0f4ac9ab79:0x3eecd961b30ca2c5!8m2!3d21.4690196!4d73.0325821!16s%2Fg%2F11k99s0v3p?entry=tts&g_ep=EgoyMDI1MDEyNy4wIPu8ASoASAFQAw%3D%3D"
              target="_blank"
              rel="noopener noreferrer"
              className={`flex pb-2 text-sm 2xl:text-base hover:underline ${styles.text}`}
            >
              <img
                src={images.map}
                alt={'Location'}
                className={`pr-5 ${styles.map}`}
              />
              Block No.110, Moti Pardi, Mangrol, Surat, Gujarat, India -394405
            </a>
          </div>
          <div
            className={`flex flex-col md:w-60 lg:w-48 xl:w-60 2xl:w-64 ${styles.brochures}`}
          >
            <span
              className={`pb-4 text-base 2xl:text-lg md:flex hidden ${styles.title}`}
            >
              {t('footer.brochures.title')}
            </span>
            <span className="pb-4 text-base 2xl:text-lg flex md:hidden">
              {t('footer.brochures.brochure.brochure-1')}
            </span>
            <span
              className={`pb-3 md:flex hidden text-sm 2xl:text-base ${styles.text}`}
            >
              {t('footer.brochures.brochure.brochure-2')}
            </span>
            <a
              href="/elyumax-brochure.pdf"
              target="_blank"
              rel="noopener noreferrer"
              id="shiny-red-button"
              className={`color w-32 h-10 flex items-center justify-center text-base 2xl:text-base ${styles.btn}`}
            >
              {t('footer.brochures.brochure.brochure-3')}
            </a>
          </div>
        </div>
      </div>
      <div className="flex justify-center space-x-3 px-4 py-2 border-t border-gray-300"></div>
      <div className="flex md:flex-row flex-col-reverse justify-between pb-10 text-center">
        <div>
          <span className={`md:pb-0 pb-2 2xl:text-lg ${styles.head}`}>
            Copyright © 2025 Elyumax{' '}
          </span>
        </div>
        <div className="flex items-center md:pb-0 pb-4">
          <img
            src={images.heart}
            alt="Heart"
            className={`px-3 md:px-2 lg:px-3 w-10 md:w-auto items-center md:pb-0 pb-2 ${styles.heart}`}
          />
          <span className={`md:pb-0 pb-2 2xl:text-lg ${styles.head}`}>
            Made by{' '}
            <a
              href="https://immence.com/"
              target="_blank"
              rel="noopener noreferrer"
              className={`font-bold ${styles.head} hover:underline`}
            >
              immence
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
